import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation from '../components/Navigation';
import TopBar from '../components/TopBar';
import BrandMark from '../components/BrandMark';

export default function MainLayout() {
  const location = useLocation();
  const getTitle = () => {
    const path = location.pathname;
    if (path === '/') return 'Command Center';
    if (path.includes('portfolio')) return 'Portfolio Overview';
    if (path.includes('maintenance')) return 'Maintenance Ops';
    if (path.includes('leases')) return 'Lease Management';
    if (path.includes('reports')) return 'Financial Reports';
    if (path.includes('demo')) return 'Demo / How It Works';
    if (path.includes('settings')) return 'System Settings';
    return 'Dashboard';
  };

  return (
    <div className="min-h-screen blueprint-grid flex flex-col md:flex-row">
      <Navigation />
      
      {/* Mobile Header */}
      <div className="md:hidden p-4 border-b border-[#004B87]/20 flex justify-between items-center bg-[#FFFFF0] sticky top-0 z-30">
        <div className="flex items-center gap-2">
          <BrandMark size="sm" className="text-[#004B87]" />
          <span className="font-bold text-sm uppercase tracking-tighter text-[#004B87]">PropertyPulse</span>
        </div>
        <div className="text-[10px] font-mono text-[#C1440E] flex items-center gap-2">
          <div className="w-1.5 h-1.5 rounded-full bg-[#C1440E] animate-pulse"></div>
          LIVE
        </div>
      </div>

      <div className="flex-1 md:ml-64 flex flex-col min-h-screen">
        <TopBar title={getTitle()} />
        
        <main className="flex-1 overflow-x-hidden pb-12">
          <div className="max-w-7xl mx-auto w-full h-full px-4 md:px-0">
            <Outlet />
          </div>
        </main>
        
        <footer className="py-6 px-4 md:px-8 border-t border-[#004B87]/10 bg-[#FFFFF0]/80 backdrop-blur-sm mt-auto">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-3 opacity-30 grayscale hover:grayscale-0 hover:opacity-100 transition-all cursor-default">
              <BrandMark size="xs" variant="rust" />
              <span className="text-[10px] font-mono tracking-[0.2em] uppercase text-[#004B87]">PropertyPulse Ecosystem</span>
            </div>
            <p className="text-[10px] font-mono tracking-[0.3em] text-[#004B87]/40 uppercase text-center md:text-right">
              Made by LingLink AI and DigLab AI
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}